<template>
  <div v-if="text" :style="tooltipStyle" class="custom-tooltip">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "CustomTooltip",
  props: {
    text: {
      type: String,
      default: ""
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  computed: {
    tooltipStyle() {
      const tooltipWidth = 350;
      const padding = 10;

      let left = this.x;
      let transformX = '-50%';

      // Check left edge
      if (left - tooltipWidth / 2 < padding) {
        left = padding;
        transformX = '0';
      }
      // Check right edge
      else if (left + tooltipWidth / 2 > window.innerWidth - padding) {
        left = window.innerWidth - padding;
        transformX = '-100%';
      }

      return {
        top: `${this.y - 10}px`,
        left: `${left}px`,
        transform: `translateX(${transformX}) translateY(-100%)`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-tooltip {
  position: fixed;
  background: #e5e7eb;
  color: #1f2937;
  border: 1px solid #9ca3af;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: normal;
  white-space: normal;
  word-break: break-word;
  max-width: 350px;
  min-width: 150px;
  z-index: 9999;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  line-height: 1.5;
  text-align: left;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 8px solid transparent;
    border-top-color: #e5e7eb;
  }

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 9px solid transparent;
    border-top-color: #9ca3af;
  }
}
</style>
